import { useGetRequest } from 'hooks/utils/useGetRequest';
import { Currencies } from 'interfaces/currencies';

const useGetCurrencyExchange = (pageIndex: number, pageSize: number, startDate: string, endDate: string): any => {
  let path = `v1/currency_exchanges/rates?size=${pageSize}&page=${
    pageIndex === 0 ? 1 : pageIndex
  }&country=ARG&show_all=true`;

  path += startDate !== '' ? `&start_date=${startDate}&end_date=${endDate}` : ``;

  const [{ data, error, loading }] = useGetRequest<Currencies>({ path });

  return {
    currencyExchange: data?.rates,
    pageInfo: {
      ...data?.meta,
      total: (data?.meta?.size ?? 0) * (data?.meta?.total ?? 0),
    },
    isLoading: loading,
    isError: error,
  };
};

export default useGetCurrencyExchange;
